import { render, staticRenderFns } from "./OTooltip.vue?vue&type=template&id=0a1ba076&scoped=true"
import script from "./OTooltip.vue?vue&type=script&lang=js"
export * from "./OTooltip.vue?vue&type=script&lang=js"
import style0 from "./OTooltip.vue?vue&type=style&index=0&id=0a1ba076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ba076",
  null
  
)

export default component.exports